// extracted by mini-css-extract-plugin
export default {"pairItem":"PairItem_pairItem__oo4sN","name":"PairItem_name__Bbl7C"};